import React, { useState } from "react";
import "animate.css";
import ArchiveItem from "../components/ArchiveItem";
import { Link } from "react-router-dom";
import project from "../project.json";

const ProjectArchive = () => {
  const [projectData, setProjectData] = useState(project);

  return (
    <div>
      <div className="row animate__animated animate__fadeIn animate__delay-1s">
        <div className="col-md-12">
          <div className="projects-archive">
            <h2>Other Noteworthy Projects</h2>
            <Link
              className="nav-link"
              to="/archive"
              spy={true}
              smooth={true}
              title="Archive"
              duration={800}
            >
              view the archive
            </Link>

            <ul className="archive-items">
              {projectData.map((data) => {
                if (data.isArchivedShow) {
                  return (
                    <ArchiveItem
                      key={data.id}
                      title={data.title}
                      description={data.description}
                      usecase={data.case}
                      live={data.live}
                      video={data.video}
                      poster={data.poster}
                      reward={data.reward}
                      techList={data.techList}
                    />
                  );
                }
              })}
            </ul>
          </div>
        </div>
      </div>
      <div className="spacer" data-height="100"></div>
    </div>
  );
};

export default ProjectArchive;
